export default {
  NO: 'N',
  YES: 'Y',
};
